<template>
	<video
		playsinline
		autoplay
		muted
		loop
		poster
		class="desktop-only demo"
		:alt="alt"
	>
		<source :src="require(`@/assets/vid/${name}.mp4`)" type="video/mp4"/>
	</video>
	<video
		playsinline
		autoplay
		muted
		loop
		poster
		class="mobile-only demo"
		:alt="alt"
	>
		<source :src="require(`@/assets/vid/${name}-sm.mp4`)" type="video/mp4"/>
	</video>
</template>

<script lang="ts" setup>
defineProps({
	name: {
		type: String,
		required: true,
	},
	alt: {
		type: String
	}
})
</script>